import React, { Component } from 'react';
import { inject, observer } from "mobx-react";
import { Row, Table, Input } from 'antd';
import TableText from "../TableText";
import { toJS, runInAction, action } from 'mobx';

const { TextArea } = Input;

@inject('store')
@observer
class App extends Component {
    @action
    onChange = (name, value, i) => {
        let data = toJS(this.props.store.monthlyAnalysis.data);
        data[i][name] = value;
        this.props.store.monthlyAnalysis.data = data;
    }
    render() {
        const { data, notes, loading } = this.props.store.monthlyAnalysis;
        const width = document.body.offsetWidth > 2100 ? document.body.offsetWidth - 1800 : 300;
        const columns = function (dataIndex, onChange) {
            return [
                {
                    title: '项目',
                    dataIndex: 'name',
                    key: 'name',
                    fixed: 'left',
                    width,
                    render: (text, record, index) => {
                        const props = {
                            text,
                            index,
                            type: 'text',
                            name: 'name',
                            onChange: onChange,
                            totalIndex: [],
                            compared: {
                                title: ["Jan"],
                                record,
                                sqlName: "monthlyAnalysis"
                            }
                        };
                        return <TableText data={{ ...props }} />
                    }
                },
                {
                    title: 'Jan',
                    dataIndex: 'Jan',
                    key: 'Jan',
                    width: 150,
                    render: (text, record, index) => {
                        const props = {
                            text,
                            index: dataIndex,
                            type: 'number',
                            name: 'Jan',
                            onChange: onChange,
                            totalIndex: [],
                            compared: {
                                title: ["Jan"],
                                record,
                                sqlName: "monthlyAnalysis"
                            }
                        };
                        return <TableText data={{ ...props }} />
                    }
                },
                {
                    title: 'Feb',
                    dataIndex: 'Feb',
                    key: 'Feb',
                    width: 150,
                    render: (text, record, index) => {
                        const props = {
                            text,
                            index: dataIndex,
                            type: 'number',
                            name: 'Feb',
                            onChange: onChange,
                            totalIndex: [],
                            compared: {
                                title: ["Feb"],
                                record,
                                sqlName: "monthlyAnalysis"
                            }
                        };
                        return <TableText data={{ ...props }} />
                    }
                },
                {
                    title: 'Mar',
                    dataIndex: 'Mar',
                    key: 'Mar',
                    width: 150,
                    render: (text, record, index) => {
                        const props = {
                            text,
                            index: dataIndex,
                            type: 'number',
                            name: 'Mar',
                            onChange: onChange,
                            totalIndex: [],
                            compared: {
                                title: ["Mar"],
                                record,
                                sqlName: "monthlyAnalysis"
                            }
                        };
                        return <TableText data={{ ...props }} />
                    }
                },
                {
                    title: 'Apr',
                    dataIndex: 'Apr',
                    key: 'Apr',
                    width: 150,
                    render: (text, record, index) => {
                        const props = {
                            text,
                            index: dataIndex,
                            type: 'number',
                            name: 'Apr',
                            onChange: onChange,
                            totalIndex: [],
                            compared: {
                                title: ["Apr"],
                                record,
                                sqlName: "monthlyAnalysis"
                            }
                        };
                        return <TableText data={{ ...props }} />
                    }
                },
                {
                    title: 'May',
                    dataIndex: 'May',
                    key: 'May',
                    width: 150,
                    render: (text, record, index) => {
                        const props = {
                            text,
                            index: dataIndex,
                            type: 'number',
                            name: 'May',
                            onChange: onChange,
                            totalIndex: [],
                            compared: {
                                title: ["May"],
                                record,
                                sqlName: "monthlyAnalysis"
                            }
                        };
                        return <TableText data={{ ...props }} />
                    }
                },
                {
                    title: 'Jun',
                    dataIndex: 'Jun',
                    key: 'Jun',
                    width: 150,
                    render: (text, record, index) => {
                        const props = {
                            text,
                            index: dataIndex,
                            type: 'number',
                            name: 'Jun',
                            onChange: onChange,
                            totalIndex: [],
                            compared: {
                                title: ["Jun"],
                                record,
                                sqlName: "monthlyAnalysis"
                            }
                        };
                        return <TableText data={{ ...props }} />
                    }
                },
                {
                    title: 'Jul',
                    dataIndex: 'Jul',
                    key: 'Jul',
                    width: 150,
                    render: (text, record, index) => {
                        const props = {
                            text,
                            index: dataIndex,
                            type: 'number',
                            name: 'Jul',
                            onChange: onChange,
                            totalIndex: [],
                            compared: {
                                title: ["Jul"],
                                record,
                                sqlName: "monthlyAnalysis"
                            }
                        };
                        return <TableText data={{ ...props }} />
                    }
                },
                {
                    title: 'Aug',
                    dataIndex: 'Aug',
                    key: 'Aug',
                    width: 150,
                    render: (text, record, index) => {
                        const props = {
                            text,
                            index: dataIndex,
                            type: 'number',
                            name: 'Aug',
                            onChange: onChange,
                            totalIndex: [],
                            compared: {
                                title: ["Aug"],
                                record,
                                sqlName: "monthlyAnalysis"
                            }
                        };
                        return <TableText data={{ ...props }} />
                    }
                },
                {
                    title: 'Sep',
                    dataIndex: 'Sep',
                    key: 'Sep',
                    width: 150,
                    render: (text, record, index) => {
                        const props = {
                            text,
                            index: dataIndex,
                            type: 'number',
                            name: 'Sep',
                            onChange: onChange,
                            totalIndex: [],
                            compared: {
                                title: ["Sep"],
                                record,
                                sqlName: "monthlyAnalysis"
                            }
                        };
                        return <TableText data={{ ...props }} />
                    }
                },
                {
                    title: 'Oct',
                    dataIndex: 'Oct',
                    key: 'Oct',
                    width: 150,
                    render: (text, record, index) => {
                        const props = {
                            text,
                            index: dataIndex,
                            type: 'number',
                            name: 'Oct',
                            onChange: onChange,
                            totalIndex: [],
                            compared: {
                                title: ["Oct"],
                                record,
                                sqlName: "monthlyAnalysis"
                            }
                        };
                        return <TableText data={{ ...props }} />
                    }
                },
                {
                    title: 'Nov',
                    dataIndex: 'Nov',
                    key: 'Nov',
                    width: 150,
                    render: (text, record, index) => {
                        const props = {
                            text,
                            index: dataIndex,
                            type: 'number',
                            name: 'Nov',
                            onChange: onChange,
                            totalIndex: [],
                            compared: {
                                title: ["Nov"],
                                record,
                                sqlName: "monthlyAnalysis"
                            }
                        };
                        return <TableText data={{ ...props }} />
                    }
                },
                {
                    title: 'Dec',
                    dataIndex: 'Dec',
                    key: 'Dec',
                    width: 150,
                    render: (text, record, index) => {
                        const props = {
                            text,
                            index: dataIndex,
                            type: 'number',
                            name: 'Dec',
                            onChange: onChange,
                            totalIndex: [],
                            compared: {
                                title: ["Dec"],
                                record,
                                sqlName: "monthlyAnalysis"
                            }
                        };
                        return <TableText data={{ ...props }} />
                    }
                }
            ];
        }
        return (
            <div className="">
                {/* 依赖ES1.1数据 */}
                <Row className="secondary_title">二．营运能力分析</Row>
                <Row className="text_c">应收账款周转天数= 30/[当月销售收入/（(月初应收账款+月末应收账款)/2）]</Row>
                <Row className="text_c">应收账款周转天数是指酒店从取得应收账款的权利到收回款项的时间。周转天数越短，说明流动资金使用效率越好。（大于30天以上需要作出解释）</Row>
                <Table
                    columns={columns(4, this.onChange)}
                    dataSource={data[4] ? [data[4]] : []}
                    size="middle"
                    bordered
                    pagination={false}
                    className="content"
                    rowKey={(record, index) => index}
                    scroll={{ x: 2100 }}
                />
                <Row className="note_title">应收账款周转天数分析</Row>
                {
                    !loading &&
                    <TextArea
                        className="note m_b_40"
                        autosize={{ minRows: 8 }}
                        defaultValue={notes.accountsReceivable}
                        onBlur={e => {
                            runInAction(() => {
                                this.props.store.monthlyAnalysis.notes.accountsReceivable = e.target.value || "";
                            })
                        }}
                        placeholder={`示例：\n（1）应收账款主要构成情况，比如某公司账期120天金额多少，占整个应收账比率多少?催讨计划？预计何时收回？`} />

                }

                <Row className="text_c">存货周转天数=30/[当月营业成本/（(月初存货余额+月末存货余额)/2）]</Row>
                <Row className="text_c">存货周转天数是指酒店从取得存货开始，至用完为止所需要的天数。周转天数越少，说明存货变现的速度越快</Row>
                <Table
                    columns={columns(5, this.onChange)}
                    dataSource={data[5] ? [data[5]] : []}
                    size="middle"
                    bordered
                    pagination={false}
                    className="content"
                    rowKey={(record, index) => index}
                    scroll={{ x: 2100 }}
                />
                <Row className="note_title">存货周转天数分析</Row>
                {
                    !loading && <TextArea
                        className="note m_b_80"
                        autosize={{ minRows: 8 }}
                        defaultValue={notes.inventory}
                        onBlur={e => {
                            runInAction(() => {
                                this.props.store.monthlyAnalysis.notes.inventory = e.target.value || "";
                            })
                        }}
                        placeholder={`示例：\n（1）存货周转天数形成的原因，比如slow moving占比多少，周转天数多少，影响整个周转天数多少？如何加快周转天数的计划？`} />}
            </div>
        );
    }
}

export default App;


// WEBPACK FOOTER //
// ./src/components/table/monthlyAnalysis/operationalCapability.js